import React from "react";
import MailChimpEmbedded from "./Static/MailChimpEmbedded";
import BlankSpace from "./Static/BlankSpace";
import TableGrid from "./Static/TableGrid";
import Wrapper from "./Static/Wrapper";
import HeadlineParagraph from "./Static/HeadlineParagraph";
import SearchBar from "./Static/SearchBar";
import Nav from "./Static/Nav";
import Footer from "./Static/Footer";
import ImageGif from "./Static/ImageGif";
import TextOverImage from "./Static/TextOverImage";
import SideBySide from "./Static/SideBySide";
import SideBySideTextButton from "./Static/SideBySideTextButton.js";
import ProductGrid from "./Static/ProductGrid";
import ProductSlider from "./Static/ProductSlider";
import ImageCarousel from "./Static/ImageCarousel";
import ImageGrid from "./Static/ImageGrid";
import Accordion from "./Static/Accordion.js";
import Youtube from "./Static/Youtube";
import EventsCalendar from "./Static/EventsCalendar";
import EventsCalendarUpcoming from "./Static/EventsCalendarUpcoming";
import SingleEventFeature from "./Static/SingleEventFeature";
import Events from "./Static/Events";
import Features from "./Static/Features";
import ContactAndHours from "./Static/ContactAndHours";
import GiftCards from "./Static/GiftCards";
import AboveSearchbarNotice from "./Static/AboveSearchbarNotice";
import PopupNotice from "./Static/PopupNotice";
import Custom from "./Static/Custom";
import CustomButton from "./Static/CustomButton";
import ButtonTop from "./Static/ButtonTop.js";
import GiftCard from "./Static/GiftCard";
import BalanceChecker from "./Static/BalanceChecker";
import Browse from "./Static/Browse";
import TextOverVideo from "./Static/TextOverVideo";
import Banner from "./Static/Banner";
import SingleTitleFeature from "./Static/SingleTitleFeature";
import TextOverParallax from "./Static/TextOverParallax";
import ButtonGrid from "./Static/ButtonGrid";
import MapStoresLocation from "./Static/MapStoresLocation.js";
import EventsGrid from "./Static/EventsGrid.js";
import EventsList from "./Static/EventsList.js";
import CustomEmbed from "./Static/CustomEmbed.js";
import TextColumns from "./Static/TextColumns.js";
import CustomForm from "./Static/CustomForm.js";
import ConstantContactEmbedded from "./Static/ConstantContactEmbedded.js";
import BuiltInEmpty from "./Static/BuiltInEmpty.js";


export const GetComponent = (props) => {

    const { name = "", id = "" } = props;

    switch (name) {

        // Global
        case "search_bar":
            return (
                <Wrapper key={id} {...props} >
                    <SearchBar />
                </Wrapper>
            )

        case "nav_bar":
            return (
                <Wrapper key={id} {...props} >
                    <Nav />
                </Wrapper>
            )

        case "footer_bar":
            return (
                <Wrapper key={id} {...props} >
                    <Footer />
                </Wrapper>
            )

        case "blank_space":
            return (
                <Wrapper key={id} {...props} >
                    <BlankSpace />
                </Wrapper>
            )

        case "table_grid":
            return (
                <Wrapper key={id} {...props} >
                    <TableGrid />
                </Wrapper>
            )

        case "headline_paragraph":
            return (
                <Wrapper key={id} {...props} >
                    <HeadlineParagraph />
                </Wrapper>
            )
        case "text_columns":
            return (
                <Wrapper key={id} {...props} >
                    <TextColumns />
                </Wrapper>
            )
        case "text_over_image":
            return (
                <Wrapper key={id} {...props} >
                    <TextOverImage />
                </Wrapper>
            )

        case "text_over_parallax":
            return (
                <Wrapper key={id} {...props}>
                    <TextOverParallax />
                </Wrapper>
            )

        case "banner":
            return (
                <Wrapper key={id} {...props} >
                    <Banner />
                </Wrapper>
            )

        case "accordion":
            return (
                <Wrapper key={id} {...props} >
                    <Accordion />
                </Wrapper>
            )

        case "text_over_video":
            return (
                <Wrapper key={id} {...props} >
                    <TextOverVideo />
                </Wrapper>
            )

        case "side_by_side_text_image":
            return (
                <Wrapper key={id} {...props} >
                    <SideBySide />
                </Wrapper>
            )

        case "side_by_side_text_button":
            return (
                <Wrapper key={id} {...props} >
                    <SideBySideTextButton />
                </Wrapper>
            )

        case "product_grid":
            return (
                <Wrapper key={id} {...props} >
                    <ProductGrid />
                </Wrapper>
            )

        case "product_slider":
            return (
                <Wrapper key={id} {...props} >
                    <ProductSlider />
                </Wrapper>
            )

        case "single_title_feature":
            return (
                <Wrapper key={id} {...props} >
                    <SingleTitleFeature />
                </Wrapper>
            )

        case "image_carousel":
            return (
                <Wrapper key={id} {...props}>
                    <ImageCarousel />
                </Wrapper>
            )

        case "image_grid":
            return (
                <Wrapper key={id} {...props}>
                    <ImageGrid />
                </Wrapper>
            )

        case "image_gif":
            return (
                <Wrapper key={id} {...props}>
                    <ImageGif />
                </Wrapper>
            )

        case "youtube":
            return (
                <Wrapper key={id} {...props}>
                    <Youtube />
                </Wrapper>
            )

        case "events_calendar":
            return (
                <Wrapper key={id} {...props}>
                    <EventsCalendar />
                </Wrapper>
            )

        case "events_calendar_upcoming":
            return (
                <Wrapper key={id} {...props}>
                    <EventsCalendarUpcoming />
                </Wrapper>
            )

        case "single_event_feature":
            return (
                <Wrapper key={id} {...props}>
                    <SingleEventFeature />
                </Wrapper>
            )


        case "above_searchbar_notice":
            return (
                <Wrapper key={id} {...props}>
                    <AboveSearchbarNotice />
                </Wrapper>
            )

        case "popup_notice":
            return (
                <Wrapper key={id} {...props}>
                    <PopupNotice />
                </Wrapper>
            )

        case "custom_html_css":
            return (
                <Wrapper key={id} {...props}>
                    <Custom />
                </Wrapper>
            )

        case "scroll_to_top":
            return (
                <Wrapper key={id} {...props}>
                    <ButtonTop />
                </Wrapper>
            )

        case "custom_button":
            return (
                <Wrapper key={id} {...props}>
                    <CustomButton />
                </Wrapper>
            )

        case "button_grid":
            return (
                <Wrapper key={id} {...props}>
                    <ButtonGrid />
                </Wrapper>
            )

        case "map_stores_location":
            return (
                <Wrapper key={id} {...props}>
                    <MapStoresLocation />
                </Wrapper>
            )

        case "gift_card_image":
            return (
                <Wrapper key={id} {...props}>
                    <GiftCard />
                </Wrapper>
            )

        case "balance_checker":
            return (
                <Wrapper key={id} {...props}>
                    <BalanceChecker />
                </Wrapper>
            )

        case "mailchimp_embedded":
            return (
                <Wrapper key={id} {...props}>
                    <MailChimpEmbedded />
                </Wrapper>
            )

        case "constant_contact_embedded":
            return (
                <Wrapper key={id} {...props}>
                    <ConstantContactEmbedded />
                </Wrapper>
            )

        case "features":
            return (
                <Wrapper key={id} {...props}>
                    <Features />
                </Wrapper>
            )

        case "gift_cards":
            return (
                <Wrapper key={id} {...props}>
                    <GiftCards />
                </Wrapper>
            )

        case "events":
            return (
                <Wrapper key={id} {...props}>
                    <Events />
                </Wrapper>
            )

        case "contact_and_hours":
            return (
                <Wrapper key={id} {...props}>
                    <ContactAndHours />
                </Wrapper>
            )

        case "browse":
            return (
                <Wrapper key={id} {...props}>
                    <Browse />
                </Wrapper>
            )

        case "events_grid":
            return (
                <Wrapper key={id} {...props}>
                    <EventsGrid />
                </Wrapper>
            )

        case "event_list":
            return (
                <Wrapper key={id} {...props}>
                    <EventsList />
                </Wrapper>
            )

        case "custom_embed":
            return (
                <Wrapper key={id} {...props}>
                    <CustomEmbed />
                </Wrapper>
            )

        case "custom_form":
            return (
                <Wrapper key={id} {...props}>
                    <CustomForm />
                </Wrapper>
            )



        default:
            return (
                <Wrapper key={id} {...props}>
                     <BuiltInEmpty />
                </Wrapper>
            )
    }

}

